import { useLayoutEffect } from "react"
import { useBooking } from "@/context/BookingContext"
import { usePortalContainer } from "./PortalContainer"

// Applies API-provided event styling — the color scheme (theme) and primary
// brand color — once event data loads, locking the rendered content to whatever
// the event specifies. In a widget it targets the shadow-root wrapper; for a
// creative the studio supplies the cell as the portal container; in the SPA
// there's no portal container so it falls back to the document root. Because
// each consumer has its own target element, a widget/creative stays on its
// event's theme regardless of the surrounding (showcase) theme — CSS tokens
// resolve to the nearest theme-class ancestor (see the `.light`/`.dark` blocks
// in index.css).
export function useBrandingSync() {
  const { state } = useBooking()
  const event = state.event
  const primaryColor = event?.primaryColor
  // Events without an explicit scheme default to dark (the product default).
  const theme = event?.theme ?? "dark"
  const container = usePortalContainer()

  useLayoutEffect(() => {
    if (!event) return
    const el = container ?? document.documentElement

    if (!import.meta.env.DEV) {
      el.classList.remove("light", "dark")
      el.classList.add(theme)
    }

    if (primaryColor) {
      el.style.setProperty("--primary", primaryColor)
      el.style.setProperty("--ring", primaryColor)
      el.style.setProperty("--sidebar-primary", primaryColor)
      el.style.setProperty("--sidebar-ring", primaryColor)
    }
  }, [event, theme, primaryColor, container])
}
